module.exports = __webpack_public_path__ + "static/logo-black-bf51d68bfc345b9ff91d3e93a97d9916.png";